import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import { fmtTime } from '../i18n/format';
import './MessageBubble.css';

export default function MessageBubble({ role, content, at, source }) {
  const { t } = useTranslation();
  const time = at ? fmtTime(at) : '';
  return (
    <div className={`message-bubble ${role === 'assistant' ? 'right' : 'left'}`}>
      {source === 'audio' && (
        <span className="mb-tag"><Icon name="microphone" size={12} />{t('conversations.audioTranscription')}</span>
      )}
      <span className="mb-text">{content}</span>
      {time && <span className="mb-time">{time}</span>}
    </div>
  );
}
